import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import DataDeletionPage from './pages/DataDeletionPage';

/**
 * TREATX-DATA-DELETION-INSTRUCTIONS-01 — canonical, hash-free public URL
 * https://treatx.health/data-deletion for Meta's
 * "Data deletion instructions URL".
 *
 * Same proven approach as LEGAL-PUBLIC-CANONICAL-URL-02 (`PublicLegalShell`):
 * the main app is a HashRouter SPA, which would rewrite the address bar to
 * `#/data-deletion`, so this standalone shell renders the page directly with
 * no router at all — the page has no route params and no navigation, so the
 * browser URL is never touched. No routing architecture was changed.
 */
export const PUBLIC_DATA_DELETION_PATH_RE = /^\/data-deletion\/?$/i;

export function matchDataDeletionPath(pathname) {
  return PUBLIC_DATA_DELETION_PATH_RE.test(pathname || '');
}

export default function PublicDataDeletionShell() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <DataDeletionPage />
      </LanguageProvider>
    </HelmetProvider>
  );
}
